// BX KICKS Animation Observer
// Handles scroll-triggered animations with Intersection Observer

let observer = null;

export const initScrollAnimations = () => {
  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  if (prefersReducedMotion) {
    // Skip animations for users who prefer reduced motion
    document.querySelectorAll('.fade-up, .slide-in, .fade-in, .slide-down').forEach(el => {
      el.classList.add('in-view');
    });
    return;
  }

  // Disconnect existing observer if present
  if (observer) {
    observer.disconnect();
  }

  // Intersection Observer configuration
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  // Create observer
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Add in-view class
        entry.target.classList.add('in-view');
        
        // Add animation-complete class after animation finishes
        setTimeout(() => {
          entry.target.classList.add('animation-complete');
        }, 1000);
        
        // Stop observing after animation triggers (performance)
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all elements with animation classes
  const animatedElements = document.querySelectorAll(
    '.fade-up, .slide-in, .fade-in, .slide-down, .stagger-item'
  );
  
  animatedElements.forEach((el) => {
    el.classList.add('will-animate');
    observer.observe(el);
  });
};

// Re-observe function for dynamically loaded content
export const observeNewElements = () => {
  // Use a timeout to ensure DOM is updated
  setTimeout(() => {
    initScrollAnimations();
  }, 100);
};

// Initialize on DOM content loaded
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }
}

export default initScrollAnimations;
